// import React, { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import './styles.css'; 
// import MobileImage from '../../Assests/Images/Mobile.png';
// import PlayStoreIcon from '../../Assests/Images/playst.png';
// import SheildImg from '../../Assests/Images/SheildIcon.png';
// import Ellipse from '../../Assests/Images/Ellipse.webp'; // Background Image

// gsap.registerPlugin(ScrollTrigger);

// const Banners = () => {
//   const phoneRef = useRef(null);
//   const cardsRef = useRef([]);

//   useEffect(() => {
//     // Phone animation on scroll
//     gsap.fromTo(phoneRef.current, 
//       { y: 100, opacity: 0 },
//       { 
//         y: 0, 
//         opacity: 1, 
//         duration: 1.5,
//         ease: "power4.out",
//         scrollTrigger: {
//           trigger: ".hero-banner",
//           start: "top 70%",
//         }
//       }
//     );

//     // Cards staggered animation
//     gsap.fromTo(cardsRef.current,
//       { y: 60, opacity: 0 },
//       { 
//         y: 0, 
//         opacity: 1, 
//         stagger: 0.2, 
//         duration: 1,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: ".hero-highlights",
//           start: "top 90%",
//         }
//       }
//     );
//   }, []);

//   return (
//     <section className="hero-banner">
//       {/* Background Ellipse Image - Center Rendered */}
//       <div className="bg-ellipse-container">
//         <img src={Ellipse} alt="" className="bg-ellipse-img" />
//       </div>
//       <div className="grid-lines-overlay">
//         <div className="v-line line-left"></div>
//         <div className="v-line line-right"></div>
//         <div className="h-line h-line-1"></div>
//         <div className="h-line h-line-2"></div>
//       </div>

//       <div className="hero-content">
//         <div className="hero-badge">
//           <span className="dot"></span> Now Live in UAE
//         </div>
//         <h1 className="hero-title">The Car Service <br /> <span style={{fontWeight:200}}> Of The Future </span></h1>
//         <p className="hero-subtitle">
//           Connecting vehicle owners with vetted vehicle mechanics and experts in real-time.
//         </p>
        
//         <div className="hero-downloads">
       
//           <button className="download-btn">
//             <img src={PlayStoreIcon} alt="" /> Download for Android
//           </button>
//         </div>
//       </div>

//       {/* Animated Phones */}
//       <div className="hero-phones" ref={phoneRef}>
//         <img src={MobileImage} alt="App screens" className="phone-img" />
//         <div className="bottom-white-fade"></div>
//       </div>

//       {/* Highlight Cards */}
//       <div className="hero-highlights">
//         {['Verified Providers', '4.8 Average Rating', 'Insured Service'].map((text, i) => (
//           <div 
//             key={i} 
//             className="highlight-card" 
//             ref={el => cardsRef.current[i] = el}
//           >
//             <div className="icon-box">
//                <img src={SheildImg} alt="" className="card-icon" />
//             </div>
//             <span className="card-text">{text}</span>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// export default Banners;
import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './styles.css'; 

import MobileImage from '../../Assests/Images/Mobile.png';
import PlayStoreIcon from '../../Assests/Images/playst.png';
import SheildImg from '../../Assests/Images/SheildIcon.png';
import Ellipse from '../../Assests/Images/Ellipse.webp';

gsap.registerPlugin(ScrollTrigger);

const Banners = () => {
  const phoneRef = useRef(null);
  const cardsRef = useRef([]);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    // 1. Optimize GSAP Calculation: Wait for images to be ready
    const timer = setTimeout(() => {
        ScrollTrigger.refresh();
    }, 1000); // Ek chhota delay taaki layout settle ho jaye

    if (imagesLoaded) {
      // Phone animation
      gsap.fromTo(phoneRef.current, 
        { y: 100, opacity: 0 },
        { 
          y: 0, 
          opacity: 1, 
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".hero-banner",
            start: "top 70%",
          }
        }
      );

      // Cards staggered
      gsap.fromTo(cardsRef.current,
        { y: 40, opacity: 0 },
        { 
          y: 0, 
          opacity: 1, 
          stagger: 0.15, 
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".hero-highlights",
            start: "top 90%",
          }
        }
      );
    }

    return () => {
        clearTimeout(timer);
        ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, [imagesLoaded]);

  return (
    <section className={`hero-banner ${imagesLoaded ? 'fade-in' : 'loading'}`}>
      
      {/* Optimization: Preload LCP Background Image */}
      <div className="bg-ellipse-container">
        <img 
          src={Ellipse} 
          alt="" 
          className="bg-ellipse-img" 
          loading="eager" // Jaldi load karne ke liye
          fetchpriority="high" // Browser ko batana ke ye important hai
          onLoad={() => setImagesLoaded(true)} // Jab ye load ho jaye tab animation chalao
        />
      </div>

      <div className="grid-lines-overlay">
        <div className="v-line line-left"></div>
        <div className="v-line line-right"></div>
        <div className="h-line h-line-1"></div>
        <div className="h-line h-line-2"></div>
      </div>

      <div className="hero-content">
        <div className="hero-badge">
          <span className="dot"></span> Now Live in UAE
        </div>
        <h1 className="hero-title">
          The Car Service <br /> 
          <span style={{fontWeight:200}} >Of The Future</span>
        </h1>
        <p className="hero-subtitle">
          Connecting vehicle owners with vetted vehicle mechanics and experts in real-time.
        </p>
        
        <div className="hero-downloads">
          <button className="download-btn">
            <img src={PlayStoreIcon} alt="Play Store" loading="lazy" /> 
            Download for Android
          </button>
        </div>
      </div>

      {/* Animated Phones - Aspect Ratio fixed for performance */}
      <div className="hero-phones" ref={phoneRef}>
        <img 
            src={MobileImage} 
            alt="App screens" 
            className="phone-img" 
            loading="lazy"
            width="1000" // Sahi dimensions dene se Layout Shift nahi hota
            height="800"
        />
        <div className="bottom-white-fade"></div>
      </div>

      <div className="hero-highlights">
        {['Verified Providers', '4.8 Average Rating', 'Insured Service'].map((text, i) => (
          <div 
            key={i} 
            className="highlight-card" 
            ref={el => cardsRef.current[i] = el}
          >
            <div className="icon-box">
               <img src={SheildImg} alt="" className="card-icon" loading="lazy" />
            </div>
            <span className="card-text">{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Banners;